import { render, staticRenderFns } from "./Three60InfoCard.vue?vue&type=template&id=23e1293e&scoped=true"
import script from "./Three60InfoCard.vue?vue&type=script&lang=js"
export * from "./Three60InfoCard.vue?vue&type=script&lang=js"
import style0 from "./Three60InfoCard.vue?vue&type=style&index=0&id=23e1293e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e1293e",
  null
  
)

export default component.exports